/**
 * LABELS & CO - Collection Auto Sort
 *
 * Order:
 * 1. CANADA READY TO SHIP (sheet wale articles - tag: ca-ready-to-ship)
 * 2. SALE                 (compare-at price wala)
 * 3. NEW ARRIVALS         (jo product "New Arrivals" collection mein hai)
 * 4. BAAKI STOCK WALE     (ready-to-ship ya normal)
 * 5. MAKE TO ORDER        ("make to order" tag)
 * 6. OUT OF STOCK         (sab se neeche - stock aate hi khud wapis apni jagah)
 */

(function () {
  function sortCollectionGrid() {
    var container = document.querySelector(
      '[data-product-container] .flex.flex-wrap'
    );

    if (!container) return;

    var items = Array.prototype.slice.call(container.children);

    if (!items.length) return;

    function attr(item, name) {
      return item.getAttribute(name) === 'true';
    }

    function getCreatedAt(item) {
      return parseInt(item.getAttribute('data-created-at'), 10) || 0;
    }

    function isSoldOut(item) {
      if (item.getAttribute('data-available') === 'false') return true;
      var card = item.querySelector('.sf__pcard');
      return !!(card && card.classList.contains('sf__pcard--soldout'));
    }

    function isOnSale(item) {
      if (attr(item, 'data-on-sale')) return true;
      var card = item.querySelector('.sf__pcard');
      return !!(card && card.classList.contains('sf__pcard--onsale'));
    }

    function getTier(item) {
      if (isSoldOut(item)) return 6;          // Out of stock
      if (attr(item, 'data-ca')) return 1;    // Canada Ready to Ship (sheet wale)
      if (isOnSale(item)) return 2;           // Sale
      if (attr(item, 'data-new')) return 3;   // New Arrivals
      if (attr(item, 'data-mto')) return 5;   // Make to Order
      return 4;                               // Baaki stock wale
    }

    var products = items.map(function (item, index) {
      return {
        item: item,
        tier: getTier(item),
        createdAt: getCreatedAt(item),
        originalIndex: index
      };
    });

    products.sort(function (a, b) {
      if (a.tier !== b.tier) return a.tier - b.tier;

      // New Arrivals ke andar latest pehle
      if (a.tier === 3 && a.createdAt !== b.createdAt) {
        return b.createdAt - a.createdAt;
      }

      // Baaki ka existing order same
      return a.originalIndex - b.originalIndex;
    });

    var changed = products.some(function (product, index) {
      return product.item !== items[index];
    });

    if (!changed) return;

    var fragment = document.createDocumentFragment();
    products.forEach(function (product) {
      fragment.appendChild(product.item);
    });
    container.appendChild(fragment);
  }

  function initSorting() {
    sortCollectionGrid();

    var target = document.querySelector('[data-product-container]');
    if (!target || !window.MutationObserver) return;

    var timeout;
    var observer = new MutationObserver(function () {
      clearTimeout(timeout);
      timeout = setTimeout(sortCollectionGrid, 100);
    });

    observer.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSorting);
  } else {
    initSorting();
  }

  // Theme AJAX filters / collection refresh
  document.addEventListener('collection:updated', function () {
    setTimeout(sortCollectionGrid, 100);
  });
})();